// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"450":"6dca6e30","664":"50b0e95d","975":"f47ebadf"}[chunkId] + ".chunk.css";
};